/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoDocumentVerifyInput = {
    clientMutationId?: string | null;
    slug: string;
};
export type TaxAssessmentsVerifyMutationVariables = {
    input: infoDocumentVerifyInput;
};
export type TaxAssessmentsVerifyMutationResponse = {
    readonly infoDocumentVerify: {
        readonly clientMutationId: string | null;
    } | null;
};
export type TaxAssessmentsVerifyMutation = {
    readonly response: TaxAssessmentsVerifyMutationResponse;
    readonly variables: TaxAssessmentsVerifyMutationVariables;
};



/*
mutation TaxAssessmentsVerifyMutation(
  $input: infoDocumentVerifyInput!
) {
  infoDocumentVerify(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoDocumentVerifyPayload",
    "kind": "LinkedField",
    "name": "infoDocumentVerify",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TaxAssessmentsVerifyMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TaxAssessmentsVerifyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2d60368b21791c77d88a216ef8edf9c2",
    "id": null,
    "metadata": {},
    "name": "TaxAssessmentsVerifyMutation",
    "operationKind": "mutation",
    "text": "mutation TaxAssessmentsVerifyMutation(\n  $input: infoDocumentVerifyInput!\n) {\n  infoDocumentVerify(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b76bc91b7eed4a1acba47d5aca60eca1';
export default node;
